jQuery(function($) {

  let scrollTop = 0;
  let activeMenuItem;

  function disable_scroll() {
    scrollTop = $(document).scrollTop()
    document.body.style.setProperty('--st', -(scrollTop) + "px");
    $('body').addClass('no-scroll');
  }

  function enable_scroll() {
    $('body').removeClass('no-scroll')
    $(document).scrollTop(scrollTop)
  }

  /* navigation */

  $('#menu-main-menu > li.menu-item-has-children>a').on('click', function(e){

    const menuItemId = parseInt(e.currentTarget.getAttribute('id').replace(/\D/g, ''));

    if (menuItemId === activeMenuItem) {
      close_active_dropdown()
      $('body').removeClass('dropdown-open')
      enable_scroll();
    } else {
      if (!activeMenuItem) {
        disable_scroll();
      }
      close_active_dropdown()
      activeMenuItem = menuItemId
      const openMenu = $(`#menu-item-${menuItemId}`)
      const dropdown = openMenu.find('>.sub-menu-wrapper')
      dropdown.toggleClass('open').show();
      $('body').addClass('dropdown-open')
    }
  })

  function close_active_dropdown() {
    if (activeMenuItem) {
      const activeMenu = $(`#menu-item-${activeMenuItem}`)
      const activeDropdown = activeMenu.find('>.sub-menu-wrapper')
      activeDropdown.removeClass('open')
      activeMenuItem = null
    }
  }

  function is_dropdown_open() {
    return $('body').hasClass('dropdown-open');
  }

  function is_cart_drawer_open() {
    return $('body').hasClass('cart-open');
  }

  function close_dropdown_menu() {
    close_active_dropdown()
    $('body').removeClass('dropdown-open')
  }

  /* close the dropdown or quote drawer if user clicks anywhere outside */
  document.addEventListener('click', e => {
    const clicked_in_cart = e.target.closest('#cart-drawer') !== null
    const clicked_in_menu = e.target.closest('header') !== null
    if (!clicked_in_menu && !clicked_in_cart) {
      if (is_dropdown_open()) {
        close_dropdown_menu()
        enable_scroll()
      }
      if (is_cart_drawer_open()) {
        close_cart_drawer()
        enable_scroll()
      }
    }
  })

  /* close the dropdown or quote drawer if user presses esc */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      if (is_dropdown_open()){
        close_dropdown_menu();
        enable_scroll();
      }
      if (is_cart_drawer_open()) {
        close_cart_drawer();
        enable_scroll();
      }
    }
  })

  function open_cart_drawer() {
    close_dropdown_menu()
    $('body').addClass('cart-open')
    $('#cart-drawer').removeClass('hidden')
  }

  function close_cart_drawer() {
    $('body').removeClass('cart-open')
  }

  /* capture WC added_to_cart event and open cart drawer */
  $( document.body ).on( 'added_to_cart', function(e, r){
    open_cart_drawer()
    disable_scroll()
  });

  $('a[href="#my-quote"]').on('click', function(e) {
    e.preventDefault()
    open_cart_drawer()
    disable_scroll()
  })

  $('#close-drawer').on('click', function() {
    close_cart_drawer()
    enable_scroll()
  })

  /* update the cart if user changes quantities in cart drawer */
  $(document.body).on('click', function(e) {
    const btn = $(e.target);
    if (btn.hasClass('update-drawer')) {
      e.preventDefault()
      btn.addClass('btn-busy')
      const data = $('#cart-drawer-form').serializeArray()
      $.post(
          kpa.ajax_url,
          {
            'action': 'kp_update_cart_drawer',
            'data': data
          },
          function() {
            window.location.href = btn.attr('href')
          }
      );
    }
  })


  $('.mobile-nav-toggle').on('click',function() {
    const mobile_nav = $('#mobile-nav');
    const open = mobile_nav.attr('aria-expanded') === 'true'
    mobile_nav.attr('aria-expanded', !open);
    mobile_nav.removeClass('hidden');
    if (!open) {
      $('body').addClass('menu-open');
      disable_scroll()
    } else {
      $('body').removeClass('menu-open');
      $('#mobile-nav .sub-menu').removeClass('show').hide();
      $('#mobile-nav li.menu-item-has-children').removeClass('open');
      enable_scroll()
    }
  })

  $('#mobile-nav li.menu-item-has-children > a').on('click', function(e) {
    const parent = $(this).parent();
    if (parent.hasClass('menu-item-has-children')) {
      e.preventDefault();
      const submenu = parent.find('>.sub-menu');
      const open = parent.hasClass('open')
      if (!open) {
        parent.addClass('open')
        submenu.addClass('show').show();
      } else {
        parent.removeClass('open')
        submenu.removeClass('show').hide();
      }
    }
  })

  $('.mobile-menu-back-btn').on('click', function() {
    $(this).parents('.sub-menu').removeClass('show');
    $(this).parents('li.menu-item-has-children').removeClass('open');
  });

  $('nav li > a[href*="#"]').on('click', function(e) {
    e.preventDefault();
  })



// header scroll animation
  var scroll_pos = 0;
  var last_scroll_pos = 0;
  var ticking = false;

  const fade_observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view')
        observer.unobserve(entry.target)
      }
    })
  }, {
    threshold: .1
  })

  const fade_in_content = document.querySelectorAll('.kp-fade-in-animation');
  fade_in_content.forEach(block => {
    fade_observer.observe(block)
  })


  const bodyEl = document.querySelector('body')
  const downThreshold = 60
  function animateMenu(scroll_pos, direction) {
    if (direction === 'down' && scroll_pos >= downThreshold && !bodyEl.classList.contains('hide-menu')) {
      bodyEl.classList.add('hide-menu')
    }
    if (direction === 'up' && bodyEl.classList.contains('hide-menu')) {
      bodyEl.classList.remove('hide-menu')
    }
  }

  function handleMenuBg(scroll_pos) {
    scroll_pos = window.scrollY;
    if (is_cart_drawer_open() || is_dropdown_open()) {
      return
    }
    if (scroll_pos >= 150) {
      bodyEl.classList.add('opaque-menu')
    } else {
      bodyEl.classList.remove('opaque-menu')
    }
  }

  window.addEventListener( 'scroll', handleScroll, {passive: true} );

  document.addEventListener('DOMContentLoaded', handleMenuBg)

  function handleScroll() {
    scroll_pos = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function() {

        let direction = getDirection(scroll_pos, last_scroll_pos);

        animateMenu(scroll_pos, direction)

        handleMenuBg()

        ticking = false;
        if (!bodyEl.classList.contains('dropdown-open')) {
          last_scroll_pos = scroll_pos;
        }

      });

      ticking = true;
    }
  }

  function getDirection(scroll_pos, last_scroll_pos) {
    if ( scroll_pos > last_scroll_pos ) {
      return 'down';
    } else if ( scroll_pos <= last_scroll_pos ) {
      return 'up';
    }
  }




})
